import { Company, Role } from "@adsk/alloy-provider";
import { Issue, WatcherObject } from "@adsk/acc-issues-types";
import { DataGetter, DataGetterArgs } from "../../../utils/types/tableTypes";
import { getProjectMemberDisplayName } from "@adsk/acc-issues-common/utils/user/oxygenUtils";
import { DisplayUserType } from "@adsk/alloy-provider";

/**
 * Formats display names of users, companies, and roles so that they are displayable by watchers column
 * in issues table, or returns a dash ("-") if the cell should be empty.
 */
export const getMultipleProjectMembersDataGetter =
  ({
    formatDisplayUser,
    rolesEntitiesMap,
    companiesEntitiesMap,
    companyIdToUserNameCountMap,
    T,
  }: {
    formatDisplayUser: (id: string) => DisplayUserType;
    rolesEntitiesMap: { [key: string]: Role };
    companiesEntitiesMap: { [key: string]: Company };
    companyIdToUserNameCountMap: {
      [companyId: string]: { [userName: string]: number };
    };
    T: any;
  }): DataGetter<Issue> =>
  ({ rowData, column }: DataGetterArgs<Issue>) => {
    const watcherObjects = rowData[column.dataKey] as WatcherObject[];
    const oxygenIds = watcherObjects?.map(item => item.id) as string[];
    return oxygenIds?.length
      ? oxygenIds
          .map(id =>
            getProjectMemberDisplayName({
              formatDisplayUser,
              rolesEntitiesMap,
              companiesEntitiesMap,
              companyIdToUserNameCountMap,
              id,
              T,
            })
          )
          .join(", ")
      : null;
  };

export const getProjectMemberDataGetter =
  ({
    formatDisplayUser,
    rolesEntitiesMap,
    companiesEntitiesMap,
    companyIdToUserNameCountMap,
    T,
  }: {
    formatDisplayUser: (id: string) => DisplayUserType;
    rolesEntitiesMap: { [key: string]: Role };
    companiesEntitiesMap: { [key: string]: Company };
    companyIdToUserNameCountMap: {
      [companyId: string]: { [userName: string]: number };
    };
    T: any;
  }): DataGetter<Issue> =>
  ({ rowData, column }: DataGetterArgs<Issue>) => {
    const id = rowData[column.dataKey] as string;
    const result = getProjectMemberDisplayName({
      formatDisplayUser,
      rolesEntitiesMap,
      companiesEntitiesMap,
      companyIdToUserNameCountMap,
      id,
      T,
    });
    if (result) {
      return result;
    }
    // if there is not result, but an id exists, its a former member
    if (id) {
      return T.translate("removedMember") as string;
    }
    return null;
  };
